/**
 * Delete one row, echoing the hash it was read with.
 *
 * Two reasons to send the hash. With `SHEETS_WRITE_QUEUE=on` the queue refuses
 * a Sheets write that does not echo it (`row_hash_required`). And the audit
 * history reads the deleted row's values out of the hash rather than reading
 * the spreadsheet a second time, so a delete shows as `value → empty` per
 * column instead of as a bare "deleted" (MOSA-368 slice 1).
 *
 * Hand-written because the generated client cannot add a query parameter: its
 * `RequestParams` type drops `query` and `data`, and the API takes the hash as
 * `?rowHash=`. The answer shape is the generated one, so the 202 queued body
 * still reaches the caller unchanged.
 */
export const deleteRecord = (
  api: unknown,
  datasourceId: string,
  collection: string,
  id: string,
  options: { rowHash?: unknown; headers?: Record<string, string> } = {}
) => {
  const hash = options.rowHash;
  const query =
    typeof hash === "string" && hash
      ? `?rowHash=${encodeURIComponent(hash)}`
      : "";
  return (api as any).request({
    path: `/data/${encodeURIComponent(datasourceId)}/${encodeURIComponent(
      collection
    )}/${encodeURIComponent(id)}${query}`,
    method: "DELETE",
    ...(options.headers ? { headers: options.headers } : {}),
  });
};
